import React from 'react'
import Card from '@mui/material/Card';

const Home = () => {
  return (
    <div>
      <Card>
          <h1>Home</h1>
      </Card>
    </div>
    
  )
}

export default Home